


export default class SyncedList<T> {

    private list: T[];

    constructor() {
        this.list = [];
    }

    processData(data: any[]): void {
        for (const item of data) {
            switch (item.type.toLowerCase()) {
                case 'add': {
                    // A fresh subscription (e.g. after a WebSocket reconnect re-subscribes an
                    // already-populated list) replays the whole current state as "add" events,
                    // even for items this list already has. Upsert instead of blindly pushing,
                    // otherwise every reconnect duplicates every existing entry.
                    const index = this.list.findIndex(existingItem => (existingItem as any).id === item.id);
                    if (index !== -1) {
                        this.list[index] = item.object;
                    } else {
                        this.list.push(item.object);
                    }
                    break;
                }
                case 'remove':
                    this.list = this.list.filter(existingItem => (existingItem as any).id !== item.id);
                    break;
                case 'update':
                    const index = this.list.findIndex(existingItem => (existingItem as any).id === item.id);
                    if (index !== -1) {
                        this.list[index] = item.object;
                    }
                    break;
                default:
                    console.warn(`Unknown operation type: ${item.type}`);
            }
        }
    }

    getList(): T[] {
        return this.list;
    }

}